import React, { useEffect, useState } from "react";

import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import swal from "sweetalert";

import CustomGreenButton from "../../../../components/shared/custom-green-button";
import { fetchSuperInstitutos } from "../../../../shared/fetchers/classics/institutos/verSuperInstitutos";

const DEFAULT_PCTS = {
  pctCliente: 40,
  pctGlobal: 30,
  pctNovedades: 30,
};

const RecomendacionFiltro = ({ onSubmit, submitting = false }) => {
  const [superInstitutos, setSuperInstitutos] = useState([]);
  const [selectedSuperInstituto, setSelectedSuperInstituto] = useState(null);
  const [nombre, setNombre] = useState("");
  const [cantidad, setCantidad] = useState(20);
  const [pctCliente, setPctCliente] = useState(DEFAULT_PCTS.pctCliente);
  const [pctGlobal, setPctGlobal] = useState(DEFAULT_PCTS.pctGlobal);
  const [pctNovedades, setPctNovedades] = useState(DEFAULT_PCTS.pctNovedades);
  const [fechaInicioCliente, setFechaInicioCliente] = useState("");
  const [fechaFinCliente, setFechaFinCliente] = useState("");
  const [fechaInicioGlobal, setFechaInicioGlobal] = useState("");
  const [fechaFinGlobal, setFechaFinGlobal] = useState("");
  const [fechaDesdeNovedades, setFechaDesdeNovedades] = useState("");

  useEffect(() => {
    const loadSuperInstitutos = async () => {
      try {
        const data = await fetchSuperInstitutos();
        setSuperInstitutos(data ?? []);
      } catch (e) {
        setSuperInstitutos([]);
      }
    };
    loadSuperInstitutos();
  }, []);

  const totalPct = Number(pctCliente) + Number(pctGlobal) + Number(pctNovedades);

  const handleSubmit = async () => {
    if (!selectedSuperInstituto) {
      await swal({ title: "Error", text: "Seleccione un Super Instituto", icon: "error" });
      return;
    }
    if (!nombre.trim()) {
      await swal({ title: "Error", text: "Ingrese un nombre para la preselección", icon: "error" });
      return;
    }
    if (!cantidad || Number(cantidad) <= 0) {
      await swal({ title: "Error", text: "La cantidad de libros debe ser mayor a cero", icon: "error" });
      return;
    }
    if (totalPct !== 100) {
      await swal({
        title: "Error",
        text: "Los porcentajes deben sumar exactamente 100",
        icon: "error",
      });
      return;
    }

    onSubmit &&
      onSubmit({
        superInstituto: selectedSuperInstituto?.nombre || "",
        nombre: nombre.trim(),
        cantidad: Number(cantidad),
        pctCliente: Number(pctCliente),
        pctGlobal: Number(pctGlobal),
        pctNovedades: Number(pctNovedades),
        fechaInicioCliente,
        fechaFinCliente,
        fechaInicioGlobal,
        fechaFinGlobal,
        fechaDesdeNovedades,
      });
  };

  const renderDateRange = (startValue, setStartValue, endValue, setEndValue, label) => (
    <>
      <label className="admin-label-text mt-3 d-block">{label}</label>
      <div className="d-flex">
        <TextField
          value={startValue}
          onChange={(e) => setStartValue(e.target.value)}
          variant="outlined"
          size="small"
          type="date"
          style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
        />
        <CustomGreenButton
          variant="contained"
          style={{ height: "40px", pointerEvents: "none" }}
          className="d-block d-md-inline"
          disableTouchRipple
          disableRipple
          disableElevation
          disableFocusRipple
        >
          Hasta
        </CustomGreenButton>
        <TextField
          value={endValue}
          onChange={(e) => setEndValue(e.target.value)}
          variant="outlined"
          size="small"
          type="date"
          style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
        />
      </div>
    </>
  );

  return (
    <div>
      <div className="d-flex align-items-center">
        <AccountBalanceIcon style={{ fontSize: "17px" }} />
        <div className="admin-main-title-dark-gray ml-2 mt-1">
          Parámetros de la preselección
        </div>
      </div>

      <label className="admin-label-text mt-3 d-block">Super Instituto:</label>
      <Autocomplete
        options={superInstitutos}
        getOptionLabel={(option) => option?.nombre ?? ""}
        value={selectedSuperInstituto}
        onChange={(_, value) => setSelectedSuperInstituto(value)}
        noOptionsText="Sin resultados"
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            placeholder="Selecciona un super instituto"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />
        )}
      />

      <label className="admin-label-text mt-3 d-block">Nombre de la preselección:</label>
      <TextField
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        variant="outlined"
        size="small"
        placeholder="Ej: Renovación 2026 - Colegio ABC"
        style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
      />

      <label className="admin-label-text mt-3 d-block">Cantidad de libros recomendados:</label>
      <TextField
        value={cantidad}
        onChange={(e) => setCantidad(e.target.value)}
        variant="outlined"
        size="small"
        type="number"
        inputProps={{ min: 1 }}
        style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
      />

      <label className="admin-label-text mt-3 d-block">Distribución por categorías (%):</label>
      <div className="d-flex flex-wrap">
        <TextField
          label="Más leídos del cliente"
          value={pctCliente}
          onChange={(e) => setPctCliente(e.target.value)}
          variant="outlined"
          size="small"
          type="number"
          inputProps={{ min: 0, max: 100 }}
          className="mr-3 mb-2"
          style={{ width: "200px", fontFamily: "'Noto Sans JP', sans-serif" }}
        />
        <TextField
          label="Más leídos global"
          value={pctGlobal}
          onChange={(e) => setPctGlobal(e.target.value)}
          variant="outlined"
          size="small"
          type="number"
          inputProps={{ min: 0, max: 100 }}
          className="mr-3 mb-2"
          style={{ width: "200px", fontFamily: "'Noto Sans JP', sans-serif" }}
        />
        <TextField
          label="Novedades"
          value={pctNovedades}
          onChange={(e) => setPctNovedades(e.target.value)}
          variant="outlined"
          size="small"
          type="number"
          inputProps={{ min: 0, max: 100 }}
          className="mb-2"
          style={{ width: "200px", fontFamily: "'Noto Sans JP', sans-serif" }}
        />
      </div>
      <div className={`admin-muted-text-small mt-1 ${totalPct === 100 ? "" : "text-danger"}`}>
        Total: {totalPct}% {totalPct !== 100 ? "(debe sumar 100%)" : ""}
      </div>

      {renderDateRange(
        fechaInicioCliente,
        setFechaInicioCliente,
        fechaFinCliente,
        setFechaFinCliente,
        "Más leídos del cliente — entre las fechas (opcional):"
      )}
      {renderDateRange(
        fechaInicioGlobal,
        setFechaInicioGlobal,
        fechaFinGlobal,
        setFechaFinGlobal,
        "Más leídos global — entre las fechas (opcional):"
      )}

      <label className="admin-label-text mt-3 d-block">Novedades — desde la fecha (opcional):</label>
      <TextField
        value={fechaDesdeNovedades}
        onChange={(e) => setFechaDesdeNovedades(e.target.value)}
        variant="outlined"
        size="small"
        type="date"
        style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
      />

      <br />
      <CustomGreenButton
        variant="contained"
        className="mt-4"
        onClick={handleSubmit}
        disabled={submitting}
      >
        Generar preselección
      </CustomGreenButton>
    </div>
  );
};

export default RecomendacionFiltro;
